import { CpfMask } from "./CpfMask";

export const cpfMask = new CpfMask();
